/** CoStar.Api.ConsumerUserData.LeadNotifications.LeadNotificationType */
export var LeadNotificationType;
(function (LeadNotificationType) {
    LeadNotificationType[LeadNotificationType["Unknown"] = 0] = "Unknown";
    LeadNotificationType[LeadNotificationType["ThirtyDayReview"] = 1] = "ThirtyDayReview";
})(LeadNotificationType || (LeadNotificationType = {}));
/** CoStar.Api.ConsumerUserData.LeadNotifications.LeadNotificationStatusType */
export var LeadNotificationStatusType;
(function (LeadNotificationStatusType) {
    LeadNotificationStatusType[LeadNotificationStatusType["Unknown"] = 0] = "Unknown";
    LeadNotificationStatusType[LeadNotificationStatusType["Unprocessed"] = 1] = "Unprocessed";
    LeadNotificationStatusType[LeadNotificationStatusType["Processing"] = 2] = "Processing";
    LeadNotificationStatusType[LeadNotificationStatusType["ExistingReviewFoundException"] = 3] = "ExistingReviewFoundException";
    LeadNotificationStatusType[LeadNotificationStatusType["Processed"] = 4] = "Processed";
    LeadNotificationStatusType[LeadNotificationStatusType["FatalException"] = 5] = "FatalException";
})(LeadNotificationStatusType || (LeadNotificationStatusType = {}));
